import Vue from 'vue'

export default {
  state: {
    loading: false,
    success: null,
    error: null,
    pageLoading: false
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setSuccess (state, payload) {
      state.success = payload
    },
    clearSuccess (state) {
      state.success = null
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setPageLoading (state, payload) {
      state.pageLoading = payload
    }
  },
  actions: {
    setLoading ({commit}, payload) {
      commit('setLoading', payload)
    },
    setSuccess ({commit}, payload) {
      commit('setSuccess', payload)
    },
    clearSuccess ({commit}) {
      commit('clearSuccess')
    },
    setError ({commit}, payload) {
      commit('setError', payload)
    },
    clearError ({commit}) {
      commit('clearError')
    },
    setPageLoading ({commit}, payload) {
      commit('setPageLoading', payload)
    },
    async apiGet ({commit, dispatch}, url) {
      commit('clearError')
      commit('setLoading', true)
      try {
        Vue.http.options.emulateJSON = true
        const response = await Vue.http.get(this.getters.apiUrl + url)
          .then(response => {
            return response.json()
          })

        commit('setLoading', false)

        if (typeof response.code !== 'undefined') {
          switch (response.code) {
            case 400:
              commit('setError', response.message)
              return Promise.reject(new Error('400'))
            case 401:
              commit('setError', response.message)
              dispatch('logoutUser')
              return Promise.reject(new Error('401'))
            case 403:
              commit('setError', response.message)
              return Promise.reject(new Error('403'))
            case 404:
              commit('setError', response.message)
              return Promise.reject(new Error('404'))
            case 405:
              commit('setError', response.message)
              return Promise.reject(new Error('405'))
            case 500:
              commit('setError', response.message)
              return Promise.reject(new Error('500'))
          }
        } else {
          return response
        }
      } catch (error) {
        commit('setLoading', false)
        commit('setError', 'Ошибка запроса')
        throw error
      }
    },
    async apiPost ({commit, dispatch}, {url, data, json = true, baseUrl = this.getters.apiUrl}) {
      console.log(data)
      commit('clearError')
      commit('setLoading', true)
      try {
        Vue.http.options.emulateJSON = json
        const response = await Vue.http.post(baseUrl + url, data)
          .then(response => {
            return response.json()
          })

        commit('setLoading', false)

        if (typeof response.code !== 'undefined') {
          switch (response.code) {
            case 400:
              commit('setError', response.message)
              return Promise.reject(new Error('400'))
            case 401:
              commit('setError', response.message)
              dispatch('logoutUser')
              return Promise.reject(new Error('401'))
            case 403:
              commit('setError', response.message)
              return Promise.reject(new Error('403'))
            case 404:
              commit('setError', response.message)
              return Promise.reject(new Error('404'))
            case 405:
              commit('setError', response.message)
              return Promise.reject(new Error('405'))
            case 500:
              commit('setError', response.message)
              return Promise.reject(new Error('500'))
          }
        } else {
          return response
        }
      } catch (error) {
        commit('setLoading', false)
        commit('setError', 'Ошибка запроса')
        throw error
      }
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    success (state) {
      return state.success
    },
    error (state) {
      return state.error
    },
    pageLoading (state) {
      return state.pageLoading
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shared.js